var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafari1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_957_679)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16532e-05 21.15V5.85001C-0.00152406 5.08135 0.148742 4.31995 0.442189 3.6095C0.735635 2.89905 1.16648 2.25354 1.71001 1.71001C2.25354 1.16648 2.89905 0.735635 3.6095 0.442189C4.31995 0.148742 5.08135 -0.00152406 5.85001 1.16532e-05H21.15C21.9187 -0.00152406 22.6801 0.148742 23.3905 0.442189C24.101 0.735635 24.7465 1.16648 25.29 1.71001C25.8335 2.25354 26.2644 2.89905 26.5578 3.6095C26.8513 4.31995 27.0015 5.08135 27 5.85001V21.15C27.0015 21.9187 26.8513 22.6801 26.5578 23.3905C26.2644 24.101 25.8335 24.7465 25.29 25.29C24.7465 25.8335 24.101 26.2644 23.3905 26.5578C22.6801 26.8513 21.9187 27.0015 21.15 27H5.85001C5.08135 27.0015 4.31995 26.8513 3.6095 26.5578C2.89905 26.2644 2.25354 25.8335 1.71001 25.29C1.16648 24.7465 0.735635 24.101 0.442189 23.3905C0.148742 22.6801 -0.00152406 21.9187 1.16532e-05 21.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5223 25.2223C19.9965 25.2223 25.2448 19.974 25.2448 13.4998C25.2448 7.02569 19.9965 1.77734 13.5223 1.77734C7.04815 1.77734 1.7998 7.02569 1.7998 13.4998C1.7998 19.974 7.04815 25.2223 13.5223 25.2223Z",
    fill: "url(#paint0_linear_957_679)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5229 24.1828V22.3828",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5229 4.60762V2.80762",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6621 24.0268L11.9747 22.2542M15.0613 4.74922L15.3738 2.97656",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8667 23.541L10.4823 21.8496M16.5617 5.14652L17.1774 3.45508",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16992 22.7623L9.06992 21.2034M17.9574 5.80982L18.8574 4.25098",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6626 21.6887L7.81962 20.3098M19.2452 6.69333L20.4022 5.31445",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32373 20.3665L6.70261 19.2095M20.319 7.78397L21.6979 6.62695",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2627 18.8369L5.82154 17.9369M21.2151 9.04941L22.774 8.14941",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46143 17.1564L5.15287 16.5407M21.8559 10.4613L23.5473 9.8457",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99023 15.367L4.76289 15.0544M22.2678 11.9678L24.0405 11.6553",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83887 13.5005H4.63887M22.4139 13.5005H24.2139",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99561 11.6514L4.76826 11.9639M22.2732 15.0505L24.0459 15.3631",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 9.84863L5.17192 10.4643M21.875 16.5437L23.5664 17.1593",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25879 8.16895L5.81763 9.06895M21.2112 17.9564L22.7701 18.8564",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32715 6.62354L6.70603 7.78055M20.3225 19.2061L21.7013 20.3631",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63965 5.31592L7.79667 6.6948M19.2222 20.3112L20.3792 21.6901",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17188 4.24316L9.07187 5.80201M17.9594 21.1956L18.8594 22.7545",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8667 3.45557L10.4823 5.14701M16.5617 21.85L17.1774 23.5415",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6553 2.99072L11.9678 4.76338M15.0544 22.2683L15.367 24.041",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5859 24.1442L12.6644 23.2477M14.3705 3.74716L14.4489 2.85059",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7593 23.8342L10.9922 22.9648M16.0586 4.05683L16.2915 3.1875",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99951 23.179L9.37987 22.3633M17.6526 4.62232L18.033 3.80664",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38916 22.2584L7.90538 21.5212M19.1331 5.48626L19.6493 4.74902",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97168 21.0583L6.60808 20.4219M20.4497 6.58024L21.0861 5.94385",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76807 19.6411L5.5053 19.1248M21.5402 7.89708L22.2774 7.38086",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83887 18.0203L4.65454 17.6399M22.3955 9.36717L23.2112 8.98682",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1958 16.2735L4.06513 16.0405M22.9731 10.9741L23.8425 10.7412",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86572 14.4342L3.7623 14.3558M23.2628 12.6497L24.1594 12.5713",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87354 12.5713L3.77011 12.6497M23.2706 14.3558L24.1672 14.4342",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18262 10.7446L4.05195 10.9776M22.9599 16.0439L23.8293 16.2769",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83105 8.98242L4.64673 9.36278M22.3877 17.6355L23.2034 18.0159",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76416 7.37988L5.5014 7.8961M21.5363 19.1239L22.2735 19.6401",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9707 5.94971L6.6071 6.5861M20.4487 20.4277L21.0851 21.0641",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37744 4.74365L7.89366 5.48089M19.1214 21.5158L19.6376 22.253",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00488 3.82275L9.38524 4.63843M17.658 22.3794L18.0383 23.1951",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.749 3.18896L10.982 4.0583M16.0483 22.9663L16.2813 23.8356",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5762 2.85986L12.6546 3.75644M14.3607 23.257L14.4391 24.1535",
    stroke: "white",
    strokeWidth: 1.003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8404 6.53857L12.5929 12.4561L5.19043 20.4886L14.4829 14.7061L21.8404 6.53857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8403 6.53857L12.5928 12.4561L14.4828 14.7061L21.8403 6.53857Z",
    fill: "#FF3B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_957_679",
    x1: 13.5221,
    y1: 25.2255,
    x2: 13.5221,
    y2: 1.77522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E6FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28CEFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_957_679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafari1);
export default __webpack_public_path__ + "static/media/safari 1.7731235dea05e96f0ec4c4882260caf4.svg";
export { ForwardRef as ReactComponent };